"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledP = exports.StyledNoItemsIndicator = exports.StyledNTextWrapper = exports.StyledH1 = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: #4c4c4c;\n  margin: 1rem auto;\n  width: 60%;\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.75rem;\n  color: #4c4c4c;\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  height: 4rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 1rem 0 0;\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  margin: 2rem 0 0;\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledNoItemsIndicator = _styledComponents.default.div(_templateObject());
exports.StyledNoItemsIndicator = StyledNoItemsIndicator;
var StyledNTextWrapper = _styledComponents.default.div(_templateObject2());
exports.StyledNTextWrapper = StyledNTextWrapper;
var StyledH1 = _styledComponents.default.h1(_templateObject3());
exports.StyledH1 = StyledH1;
var StyledP = _styledComponents.default.p(_templateObject4());
exports.StyledP = StyledP;